export const ar = {
  language: "العربيه",
  home: {
    afaaq:"مدرسة افاق الخاصة",
    Welcome:"مرحبا",
    EducationalFeature:"مميزات تربوية وتعليمية",
Kindergarten:"قسم رياض الأطفال",
BasicSection:"قسم الأساسي",
PostBasicection:"قسم ما بعد الأساسي",
Searchbystudentname:"ابحث بالاسم",
filterByGrade:"تصنيف بالمرحلة",
filterByStage:"تصنيف بالصف",
Tuitionfees:"الرسوم الدراسية",
files:"مرفقات",
Transportation:"بيانات النقل والسكن",

  Privatetransportation:"نقل خاص",
  Schooltransportation:"نقل مدرسي",
    Tracknumber:"رقم السكة",
Housenumber:"رقم المنزل",
Nearestknownlocation:"أقرب مكان معروف",
Linklocation:"رابط موقع المنزل على الخريطة",
Healthcondition:"الحالة الصحية",
Pronunciationcorrectness:"سلامة النطق",
acknowledge:"أقر بالاطلاع والموافقة على شروط التسجيل والتعاقد المالي",
BilingualSection:"قسم ثنائي اللغة",
  registrationTermsTitle: "يتم التسجيل بعد الاطلاع على كافة تفاصيل التسجيل في المدرسة وهي: ",
  registrationTerms: [
    "1.	يجب إرفاق جميع المستندات المطلوبة لتسجيل الطالب.",
    "2.	يلتزم ولي الامر بتسجيل الطالب في البوابة التعليمية، الإدارة تتابع عملية التسجيل إلى حين إتمامها.",
    "3.	يجب التوقيع على وثيقة التسجيل وملحق التعاقد المال معا.",
    "4.	للمدرسة مواعيدها الخاصة المحددة من وزارة التربية والتعليم في بدء العام الدراسي، وإجازة المنتصف، ووقت نهاية العام الدراسي، وعليه يرجى من ولي الامر التقيد بهذه المواعيد.",
    "5.	لا يسمح بالغياب المتكرر للطالب، ولا تتحمل المدرسة أي تأخر أو فاقد تعليمي بسبب الغياب، وتستثنى من ذلك الحالات المرضية.",

  ],
  "Doeshesufferfromanyillnesses":" هل يعاني من أمراض?",
KindergartenContent:`
- منهج متكامل ينمي الجوانب التعليمية والتربوية
- تعلم متميز قائم على الطرق الحديث للأركان التعليمية
- انشطة متنوعة تراعي الفروق الفردية
- بيئة تعليمية آمنة ومحفزة
- تنمية القيم والسلوك الإيجابي
- معلمات مؤهلات ومتمكنات تربويًا
- اهتمام بالنمو النفسي والاجتماعي للطفل
 - اشراك الطفل في المسابقات والمحافل الداخلية والخارجية
- تواصل فعال مع أولياء الأمور
- استخدام وسائل تعليمية متنوعة وجذابة محسوسة ورقمية
- شراكات مع مؤسسات المجتمع المحلي

`,
  financialContractTitle: "التعاقد المالي",

    Effortless: "تتبع حضور الطلاب بسهولة",
    Say: "قل وداعًا للحضور اليدوي والأوراق الرسمية. يساعد نظامنا الذكي المدارس على تتبع الحضور وإخطار أولياء الأمور على الفور وإنشاء تقارير مفيدة - كل ذلك في مكان واحد",
    GetStarted: "ابدأ الآن",
    QuickSummary: "ملخص سريع",
    Summary: "ملخص",
    TotalTeachers: "إجمالي المعلمين",
    TotalClasses: "إجمالي الفصول",
    TotalStudents: "إجمالي الطلاب",

    
    WeeklyAttendanceReport: "تقرير الحضور الأسبوعي",
    present:"حاضر",
    Absent:"غائب",

    AttendedAbsent: "حضور / غياب",
    Cash:"الدفع في المدرسه",
    visa:"فيزا ",
    Installments:"تقسيط ",
Lastpaymentdate:"أخر ميعاد سداد",
paymentdate:"ميعاد سداد",
rePay:"أعادة الدفع",

    Absent: "غائب",
    send: "ارسال",
    Attended: "حضور",
    TotalStudentsText: "إجمالي الطلاب",
Academicyearexpenses:"مصاريف السنة الدراسية",
Academicyear:" السنة الدراسية",
pending:"قيد الانتظار",
Verygood:"جيد جدا",
Doesnotread:"لا يقرأ",
PreviousSchoolData:"بيانات المدرسة السابقة ",
randomlyidentifyletters:"هل يميز الحروف بشكل عشوائي؟",
readshortwords:"يقرأ كلمات قصيرة؟",
readshortsentences:"يقرأ جمل قصيرة؟",
surahsfromtheQuran:"يحفظ سورا من القرآن؟",
BehavioralData:"بيانات الطالب السلوكية",
DistinctiveSkills:"مهارات مميزة للطالب",
StudentBehaviors:"سلوكيات الطالب",
Choosebehaviors:"اختر السلوكيات",
hyperactive:"حركي",
irritable:"عدواني",
inflexible:"عنيد",
introvert:"انطوائي",
shy:"خجول",
articulate:"طبيعي",
Mothersdata:"بيانات الأم",
Mothersname:"اسم الام",
Nationality:"الجنسية",
Civilnumber:"الرقم المدني",
Motherphonenumber:"رقم هاتف الأم",
Othereducationalnotes:"ملاحظات تعليمية أخرى",
    "TodaysAttendance":"الحضور اليوم",
    "ManageYourSchoolsEfficiently":"إدارة مدارسك بكفاءة",
    "abouttitle": "لماذا تختار نظامنا؟",
    "aboutsubtitle": "نظامنا بسيط وفعال—فقط 3 خطوات سهلة",
    "feature1title": "تتبع الحضور التلقائي",
    "feature1description": "وداعًا لنداء الأسماء يدويًا! يمكن للمعلمين تسجيل الحضور بنقرة واحدة، وتسجيل الغيابات تلقائيًا.",
    "feature2title": "وصول متعدد المستخدمين وصلاحيات حسب الدور",
    "feature2description": "مصمم للمديرين والمعلمين، لضمان حصول الجميع على المستوى المناسب من الوصول إلى البيانات التي يحتاجونها.",
    "feature3title": "يعتمد على السحابة وآمن",
    "feature3description": "يمكن الوصول إلى النظام من أي مكان وعلى أي جهاز، مع تشفير البيانات بالكامل وتخزين سحابي آمن لحماية معلومات الطلاب.",
    "feature4title": "سياسات حضور قابلة للتخصيص",
    "feature4description": "يمكن للمدارس تحديد قواعد الحضور الخاصة بها، وسياسات التأخير، وحدود الغياب، مما يجعل النظام قابلاً للتكيف مع المؤسسات التعليمية المختلفة.",
    "howtitle": "كيف يعمل؟ دليل خطوة بخطوة",
    "howdescription": "نظامنا بسيط وفعال - فقط 3 خطوات سهلة",
    "step1Title": "تسجيل الدخول إلى النظام",
    "step1Description": "يقوم المعلمون والطلاب بتسجيل الدخول بأمان من أي جهاز.",
    "step2Title": "تحديد الحضور",
    "step2Description": "تتبع حضور الطلاب بسهولة بنقرة واحدة.",
    "step3Title": "الإشعارات والتقارير",
    "step3Description":
      "احصل على تحديثات فورية، وتوفر المدارس تقارير تفصيلية عن الحضور.",
    "contacttitle": "اتصل بنا",
    "contactsubtitle": "هل لديك أي استفسارات؟ فقط أرسل لنا رسالة!",
    "contactInfo": "معلومات الاتصال",
    "phone": "رقم الهاتف",
    "email": "البريد الإلكتروني",
    Howcanweserveyou:"كيف يمكننا خدمتكم؟",
    Wewelcome:"يسعدنا استقبال استفساراتكم وملاحظاتكم واقتراحاتكم",


    "ParentEmailAddress":"البريد الالكتروني لولي الامر",
    "location": "١٥ شارع التحرير، وسط البلد، القاهرة، مصر، ١١٥١١",
    "namePlaceholder": "الاسم",
    "nameStudent": "اسم الطالب",
    "nameEmployee": "اسم الموظف",
    selectnameEmployee:"أختار اسم الموظف",
editEmploye:"تعديل الموظف",
editpermissions:"تعديل الصلحيات",

    "emailPlaceholder": "البريد الإلكتروني",
    "phonePlaceholder": "رقم الهاتف",
    "messagePlaceholder": "اكتب رسالتك...",
    "sendMessage": "إرسال الرسالة",
    "Loading": "جاري التحميل.........",
    "reachUs": "تواصل معنا",
    contactusPargraph:"يرجى الاتصال على الأرقام التالية، أو من خلال البريد الإلكتروني",

    "quickLinks": "روابط سريعة",
    "home": "الرئيسية",
    "howItWorks": "كيف يعمل؟",
    "contactUs": "اتصل بنا",
    "newsletterTitle": "انضم إلى نشرتنا الإخبارية",
    "newsletterPlaceholder": "عنوان بريدك الإلكتروني",
    "subscribe": "اشتراك",
    "newsletterNote": "* سنرسل لك تحديثات أسبوعية لإدارة الأدوات بشكل أفضل.",
    "features": "المميزات",
    "resonOfreject": "سبب الرفض",

    "login": "تسجيل الدخول",
    downloadpdf:"حمل ملف التسجيل",
    download:"حمل",

    "user": "المستخدم",
    "language": "العربية",
    "switchTo": "الإنجليزية",
    "welcome": "مرحبًا ، قم بتسجيل الدخول إلى حسابك",
    "subtitle": "إنه لمن دواعي سرورنا أن نرحب بكم!",
    "passwordPlaceholder": "كلمة المرور",
    "loggingIn": "جاري تسجيل الدخول...",
    "fillFields": "يرجى ملء جميع الحقول",
    "invalidCredentials": "بيانات الاعتماد غير صالحة ، يرجى المحاولة مرة أخرى.",
    "successMessage": "تم تسجيل الدخول بنجاح!",
    "successSuccessfully": "تم الاضافة  بنجاح!",

    "dashboard": "لوحة التحكم",
    "schools": "المدارس",
    "school": "المدرسة",
    "structure": "الهيكل المدرسي",

    "stages": "المراحل",
    "grades": "الصفوف",
    "grade": "الصف",

    "subjects": "المواد الدراسية",
    "subject": "المادة الدراسية",

    "teachers": "المعلمين",
    "teacher": "المعلم",

    "classes": "الفصول والجداول",
    "class": "الفصل",
    Lateattendance:"تأخير الحضور",


    "addclass": "اضافة فصل",
    "ParentPhone": "رقم ولي الامر",

    "students": "الطلاب",
    "addStudents": "اضافة طالب",

    "attendanceHistory": "سجل الحضور",
    "markAttendance": "تسجيل الحضور",
    "profile": "الصفحة الشخصية",
    "changePassword": "تغيير كلمة المرور",
    "or":"أو",
    "logout": "تسجيل الخروج",
    "export":"تحميل الملف",
    "schoolID":"رقم المدرسة",
    "addschools":"اضافة مدرسة",
    "Save":"حفظ",
    "SelectGender":"اختار النوع",
    "SelectClass":"اختار الفصل",
    "SelectTeacher":"اختار المعلم",
"Day":"اليوم",


    "SelectSubject":"اختار المادة الدراسية",

    "gender":"النوع",
    "male":"ذكر",
    "female":"أنثي",
    "Oldpassword":"كلمة المرور الحالية",
    "Newpassword":"كلمة المرور الجديدة",
    "Confirmpassword":"تأكيد كلمة المرور",
    "SchoolStracture":"هيكلة المدرسة",
    "addStage":"اضافة مرحلة",
    "Stage":"المرحلة",

    "add":"اضافة",
    "stageName":"اسم المرحلة",
    priceTotal:"السعر النهائي",
    "gradeName":"اسم الصف",
    fatherDataTitle: "بيانات الأب",
siblingCount: "عدد الإخوة",
siblingOrder: "الترتيب بين الإخوة",
birthDate: "تاريخ الميلاد",
studentDataTitle: "البيانات الشخصية للطالب",
studentCivilId: "الرقم المدني",
studentNameAr: "الاسم الكامل (بالعربية) ",
studentNameEn: "الاسم الكامل (بالإنجليزية) ",

    "ID":"رقم التسلسل",
    "AddGrades":"اضافة صف",
    "SelectStage":"اختار المرحلة",
    "addSubject":"اضافة مادة دراسية",
    "Semester":"الفصل الدراسي",
    "SelectGrades":"اختار الصف",
    "SelectSemester":"اختار الفصل الدراسي",
    
    "firstsemster":"الفصل الدراسي الاول",
    "secondsemester":"الفصل الدراسي الثاني",
"addteachers":"اضافة معلم",
"MaxStudents":"الحد الأقصى للطلاب",
"sessionnumber":"عدد الحصص",
"Session":"الحصة",
"SelectTimeTable":"قم بتحميل جدول الحصص",
identity_number:"رقم الهوية",
type:"النوع",
    aboutafaq:"عن افاق",

"timeTable":"جدول الحصص",
"Selectday":"اختار اليوم",
"SelectSession":"اختار الحصة",
'monday': 'الاثنين',
'tuesday': 'الثلاثاء',
'wednesday': 'الأربعاء',
'thursday': 'الخميس',
'friday': 'الجمعة',
'saturday': 'السبت',
'sunday': 'الأحد',
  january: "يناير",
  february: "فبراير",
  march: "مارس",
  april: "أبريل",
  may: "مايو",
  june: "يونيو",
  july: "يوليو",
  august: "أغسطس",
  september: "سبتمبر",
  october: "أكتوبر",
  november: "نوفمبر",
  december: "ديسمبر",
"Selectyear":"اختار السنة",
"SelectMonth":"اختار الشهر",
"SelectDays":"اختار اليوم",
"Month":"الشهر",
"role":"الوظيفة",
Worklocation:"مقر العمل",
mainexpenses:"النفقة الاساسية",
Educationallevel:"المستوى التعليمي",
parentStatus: "حالة الوالدين",
relativeName: "اسم أحد الأقارب (للتواصل في الضرورة)",
relationship: "صلة القرابة ",
relativePhone: "رقم هاتف القريب",
parentsTogether: "معا",
parentsSeparated: "منفصلان",
parentsWidower: "أرمل",
parentsWidow: "أرملة",

fatherName: "اسم الأب",
fatherNationality: "الجنسية",
fatherCivilId: "الرقم المدني",
fatherPhone: "رقم هاتف الأب",
fatherJob: "الوظيفة",
fatherWorkplace: "مقر العمل",
fatherEducationLevel: "المستوى التعليمي",
jobTitle:"المسمي الوظيفي",








"status":"الحالة",
"settings":"الاعدادات",
"firstSection":"القسم الاول",
"secondSection":"القسم الثاني",
"thirdSection":"القسم الثالث",
title_ar: "العنوان بالعربية",
title_en: "العنوان بالانجليزية",

description_ar: "الوصف بالعربية",
description: "الوصف",
description_en: "الوصف بالانجليزية",

image: "الصورة",
UploadMainImage:"تحميل الصورة الرئيسية",
Upload:"تحميل ",
ClickorDraganImage:"انقر أو اسحب صورة",
subtitle1_ar: "العنوان الفرعي 1 بالعربية",
subtitle_ar: "العنوان الفرعي بالعربية",

subtitle1_en: "العنوان الفرعي 1 بالانجليزية",
subtitle_en: "العنوان الفرعي بالانجليزية",



subtitle2_ar: "العنوان الفرعي 2 بالعربية",
subtitle2_en: "العنوان الفرعي 2 بالانجليزية",

subtitle3_ar: "العنوان الفرعي 3 بالعربية",
subtitle3_en: "العنوان الفرعي 3 بالانجليزية",


subtitle4_ar: "العنوان الفرعي 4 بالعربية",
subtitle4_en: "العنوان الفرعي 4 بالانجليزية",


subdescribtion1_ar: "الوصف الفرعي 1 بالعربية",
subdescribtion1_en: "الوصف الفرعي 1 بالانجليزية",
subdescribtion_en: "الوصف الفرعي  بالانجليزية",


subdescribtion2_ar: "الوصف الفرعي 2 بالعربية",
subdescribtion_ar: "الوصف الفرعي  بالعربية",

subdescribtion2_en: "الوصف الفرعي 2 بالانجليزية",


subdescribtion3_ar: "الوصف الفرعي 3 بالعربية",
subdescribtion3_en: "الوصف الفرعي 3 بالانجليزية",



subdescribtion4_ar: "الوصف الفرعي 4 بالعربية",
subdescribtion4_en: "الوصف الفرعي 4 بالانجليزية",
"TotalSchools":"أجمالي المدارس",
"notfountTitle":"لم يتم العثور على الصفحة",
"notfountParagraph1":"نأسف، لم يتم العثور على الصفحة المطلوبة",
"notfountParagraph2":"يرجى العودة إلى الصفحة الرئيسية",
"MarkAttendance":"تحصيل الغياب",
"areyousureyouwantdelet":"هل أنت متأكد أنك تريد حذف هذا؟",
"areyousureyouwantreject":"هل أنت متأكد أنك تريد رفض هذا؟",
"areyousureyouwantaccept":"هل أنت متأكد أنك تريد قبول هذا؟",
"delete":"حذف",
"close":"غلق",
"edit":"تعديل",
"notmatch":"كلمة المرور الجديدة وكلمة المرور المؤكدة غير متطابقتين!",
"from":"من",
"to":"الي",
"chooseStageFirst":"الرجاء اختيار المرحلة اولا",
"chooseYearFirst":"الرجاء اختيار السنة اولا",
"chooseMonthFirst":"الرجاء اختيار الشهر اولا",
ressonOfException:"سبب الاستثناء",
"chooseGradeandSemsterirst":"اختر الصف والفصل الدراسي أولاً",
"chooseGradefirst":"اختر الصف أولاً",
"chooseGrade":"اختر الصف ",
"deleteTimeTable":"حذف الجدول الدراسي",

"Generaldata":"بيانات عامة",
"Financialaccounting":"المحاسبة المالية",
"Presenceandabsence":"الحضور والغياب",
"Teacherreserve":"احتياط المعلمين",
PreviewSignature:"عرض الامضاء",
Preview:"عرض ",

"ComingSoon":"قريباً",
"Addpermissions":"إضافة صلاحيات",
"permissions":"صلاحيات",
"selectpermissions":"حدد الصلاحيات",
"AccountingandExpensesOfficer":"موظف المحاسبة والمصروفات",
"Accountingemployee":"موظف المحاسبة",
"Publicemployee":"موظف عام ",
"employee":"الموظف",
"employe":"الموظفيين",


"Financialofficer":"موظف مالي",
"ProcurementOfficer":"موظف المشتريات",
"PurchasingManager":"مدير المشتريات",
"Maintenancemanager":"مدير الصيانة",
"Finance":"المالية",
"Purchases":"المشتريات",
"Salaries":"الرواتب",
"Maintenance":"الصيانة",
"Sales":"المبيعات (رسوم الطلاب)",
"all":"الكل",
"Studyexpenses":"نفقات الدراسية و الاسثناءات ونفقات دراسيه ",
"expenses":"المصروفات",
"income":"الإيرادات",

forms:"استمارات",
forgetPassword:"نسيت كلمة المرور؟",
receipt:"إيصال",
registrationconditions:"شروط التسجيل",
FeesSchedule:"جدول رسوم",

"Exceptions":"استثناءات",
"FinancialDirector":"المدير المالي",
"salesemployee":"موظف المبيعات (رسوم الطلاب)",
"Purchasingemployee":"موظف المشتريات",
"Salariesemployee":"موظف الرواتب",
"Maintenanceemployee":"موظف الصيانة",
"Administrators":"الاداريين",
"Totalsales":"اجمالي المبيعات (رسوم الطلاب)",
"price":"السعر",
"date":"تاريخ",
"tests":"الاختبارات",
"Totalmaintenanceprice":"اجمالي سعر الصيانة",
"Totalpurchasesprice":"اجمالي سعر المشتريات",
"Total":"اجمالي",
Partnership:"الشراكة مع أولياء الأمور والمجتمع",
Effectivecollaboration:"- تعاون فعال مع الأسرة- تنظيم فعاليات وأنشطة مشتركة- شراكات مع مؤسسات المجتمع المحلي",
Vision:"الرؤية ",
Mission:"الرسالة",
Objectives:"الأهداف",
Values:"القيم",
region:"اسم المنطقة",

VisionContent:"تعليم متميز ذو جودة عالية مواكب للتطور والتكنولوجيا.",
MissionContent:"اعداد جيل مثقف مبدع ذو خلق قويم قادر على مواجهة تحديات العصر بطابعه العماني الأصيل.",
ObjectivesContent: `1- تحقيق معظم طلبة المدرسة مستوى تحصيلي لا يقل عن جيد في مختلف المواد الدراسية.
2- رفع مستوى كفاءة وأداء العاملين بالمدرسة وخصوصا فيما يتعلق بتوظيف التقانة الحديثة وتفعيل تطبيقات الذكاء الاصطناعي على تنوعها.
3- تفعيل المنهج المدرسي وفق رؤية تطوير التعليم للنهوض بالمجتمع.
4- مشاركة أسر الطلبة في الإشراف على تعليم الطالب وتحفيزه وتوفير بيئة التعلم الملائمة.
5- تبنِّي جميع أفراد المدرسة قيم الاحترام والمسؤولية المتبادلة.
6- اكتشاف المواهب الطلابية وتنميتها لخدمة المجتمع.
7- تنمية روح المواطنة والانتماء والحفاظ على مكتسبات الوطن.
8- غرس القيم الحميدة لرفع المستوى الأخلاقي وتعديل السلوكيات للأفضل.`,

ValuesContent:`
1 الطالب هو محور العملية التعليمية.
2 المعلم هو محور العملية التربوية وهو القادر على الغرس والتنشئة.
3 التمسك بالدين الإسلامي وقيمه السمحة المعتدلة كأساس للمواطنة الصالحة.
4 تعليم الطالب عملية مشتركة بين المدرسة والاسرة.
5 التعاون (الطلبة، الهيئة التعليمية، المجتمع المحلي).
6 الاحترام (الطالب لذاته، الطالب لمعلمه، الكادر المدرسي، المجتمع المحلى).
7  الشراكة المجتمعية (المدرسة والاسرة، المدرسة والمجتمع المحلي).

`,
"statusStudent":"الصف الاول الابتدائي الفصل الدراسي الاول",
AllFinance:"جميع النفاقات المالية",
section:"القسم",
Purchasesprice:"قيمة المشتريات",
Salariesprice:"قيمة المرتبات",
Salary:"الراتب",
Discounts:"الخصم",
Incentives:"الحوافز",
Bonuses:"المكافآت",
Reasonfordiscount:"سبب الخصم ",
Reasonforrewards:"سبب المكافات",

Paid:"مدفوع",
unPaid:"غير مدفوع",
    Registrationandtuitionfees:"رسوم التسجيل والدراسه",
governorates:"المحافظات",
method:"طريقة",
RemainingPrice:"المبلغ المتبقي",
PaidPrice:"السعر المدفوع",
Iaccept:"أوافق",
Registrationfile:"ملف التسجيل",
RegistrationfileDone:"ملف التسجيل تم تحميل",
theTermsConditions:"على الشروط والأحكام",
reject:"رفض",
amount_paid:"المبلغ الذي تم دفعه",
accept:"قبول",
"Notifications":"الاشعارات",
addExceptions:"إضافة استثناءات",
addEmploye:"إضافة موظف",

showExceptions:"عرض استثناءات",
Paycustomerdata:"دفع بيانات العملاء",
signupasStudent:"تسجيل كطالب",
Pleasesendthereceipt:"يرجي أرسال الايصال",
Pleasesendtheformfeetomyaccount:"يرجي ارسال قيمة الاستمارة علي حساب",
bankAccount:"عن طريق الحساب البنكي",
Chooseapaymentmethod:"اختيار طريقة الدفع",
payNow:"أدفع الان",

currancy:"ريال عماني",
Pleasepaytheregistrationformfee:"يرجي دفع ",
registrationform:" استمارة التسجيل",
signature: "التوقيع",
signatureOnline: "التوقيع أونلاين",
delete_ar: "حذف",
drawSignature: "التوقيع (الرسم أدناه):",
includeSignature: "تضمين التوقيع في ملف PDF",
downloadSignedPdf: "قم بتنزيل ملف PDF الموقع",
or: "أو",
signAndResend_ar: "وقع الملف وقم بإعادة إرساله",
signAndResend: "وقع الملف وقم بإعادة إرساله",
PickPDF:"اختر ملف PDF",
Transporttype:"نوع النقل",
address:"العنوان",
FilterBy:"فلتر ب",
copyRighgt:" جميع الحقوق محفوظة لمدارس الافاق - برمجة وتصميم ",
ourServices:"خدماتنا",
Leading:"ميزات تعليمية وتربوية رائدة",

  financialContract: `
  <h5>أولا : مصطلحات العقد :</h5>
  <p>يكون‭ ‬للمصطلحات‭ ‬الآتية‭ ‬الدلالات‭ ‬المبيّنة‭ ‬أدناه‭:</p>
  <ul>
    <li>الطّرف‭ ‬الأوّل‭: ‬مدرسة‭ ‬الآفاق ‬الخاصّة‭.‬</li>
    <li>الطّرف‭ ‬الثاني‭: ‬وليّ‭ ‬أمر‭ ‬الطّالب‭.‬</li>
  </ul>

  <h5>ثانيا‭: ‬موادّ‭ ‬العقد‭ ‬وبنوده‭:</h5>
  <p>بالضغط على زر الموافقة أدناه، فإنك تقر بالموافقة على ما يلي :</p>
  <ol>
    <li>يُعَدُّ‭ ‬هذا‭ ‬العقد‭ ‬الوثيقةَ‭ ‬الرسميّة‭ ‬المنظّمة‭ ‬للعلاقة‭ ‬المالية‭ ‬بين‭ ‬طرفَيْ‭ ‬العقد‭ ‬المرجع‭ ‬الأساس‭ ‬لدى‭ ‬حدوث‭ ‬أيّ‭ ‬خلاف‭ ‬أو‭ ‬إشكال‭.‬</li>
    <li>يكون‭ ‬الطّرف‭ ‬الثاني‭ ‬ـ‭ ‬بتوقيعه‭ ‬على‭ ‬هذه‭ ‬الوثيقة‭ ‬ـ‭ ‬مسؤولا‭ ‬مسؤوليّة‭ ‬كاملة‭ ‬بالإيفاء‭ ‬بكافّة‭ ‬الالتزامات‭ ‬المالية‭ ‬الموضّحة‭ ‬في‭ ‬هذه‭ ‬الوثيقة‭.‬</li>
  </ol>

  <h5>الرسوم‭ ‬الدّراسيّة‭:</h5>
  <p>وتشمل‭ ‬الآتي:</p>
  <ul>
    <li>الرسوم‭ ‬الدّراسيّة‭ ‬السنويّة، الموضحة  <a href="/expenses"><span style="background-color: #e63967; color: white; padding: 4px 16px; border-radius: 8px; text-decoration: none;">في الجدول التالي</span> </a>.</li>
    <li>رسوم‭ ‬النّقل‭ ‬والمواصلات‭.‬</li>
    <li>رسوم‭ ‬الكتب‭ ‬والتّغذية‭.‬</li>
  </ul>

  <ul>
    <li>يلتزم‭ ‬الطّرف‭ ‬الثاني‭ ‬بالانضباط‭ ‬في‭ ‬دفع‭ ‬الرّسوم‭ ‬الدّراسيّة‭ ‬بأحد‭ ‬الخيارات‭ ‬الآتية‭:‬</li>
    <ul>
      <li>دفع الرسوم السنوية دفعة واحدة (قبل نهاية الفصل الدراسي الأول).</li>
      <li>دفع الرسوم السنوية على دفعتين (الفصل الأول والفصل الثاني).</li>
      <li>دفع الرسوم السنوية بدفعات شهرية.</li>
    </ul>
<li>
إذا تأخر الطرف الثاني في سداد الرسوم بعد التاريخ المحدد، يحق للطرف الأول المطالبة بالدفع بكل الوسائل المتاحة.</li>
 <li> في‭ ‬حال‭ ‬تَأَخَّر‭ ‬الطّرف‭ ‬الثاني‭ ‬في‭ ‬سداد‭ ‬الرّسوم‭ ‬عن‭ ‬الموعد‭ ‬المحدّد‭ ‬له‭ ‬حسب‭ ‬الخيار‭ ‬المتّفق‭ ‬عليه؛‭ ‬يكون‭ ‬من‭ ‬حقّ‭ ‬الطرف‭ ‬الأوّل‭ ‬مُطالبته‭ ‬في‭ ‬الإيفاء‭ ‬بالالتزام،‭ ‬ومُتابعته‭ ‬بكلّ‭ ‬الوسائل‭ ‬المتاحة‭ ‬له‭.‬</li>
    <li>إذا‭ ‬فقد‭ ‬الطّالب‭ ‬كتبه‭ ‬أو‭ ‬أيّ‭ ‬وثيقة‭ ‬تُسلّم‭ ‬له‭ ‬من‭ ‬المدرسة؛‭ ‬يُطلب‭ ‬منه‭ ‬دفع‭ ‬بدل‭ ‬مفقود‭.‬</li>
    <li>يُحظر‭ ‬انسحاب‭ ‬الطّالب‭ ‬بعد‭ ‬حجز‭ ‬المقعد‭ ‬إلاّ‭ ‬في‭ ‬حالات‭ ‬الضّرورة‭ ‬القُصوى‭ ‬كالسّفر‭ ‬أو‭ ‬المرض‭ ‬مع‭ ‬إثبات‭ ‬رسميّ‭.‬</li>
    <li>يُعتبر‭ ‬مبلغ‭ ‬حجز‭ ‬المقعد‭ ‬حقًّا‭ ‬ثابتا‭ ‬للمؤسسة‭ ‬ولا‭ ‬يُسترجع‭ ‬في‭ ‬حال‭ ‬الانسحاب‭.‬</li>
    <li>يلتزم‭ ‬ولي‭ ‬الأمر‭ ‬بدفع‭ ‬الرسوم‭ ‬كاملة‭ ‬إذا‭ ‬انسحب‭ ‬الطالب‭ ‬بعد‭ ‬بداية‭ ‬الدراسة‭.‬</li>
    <li>في حال تأخر الدفع لأكثر من ثلاثة أشهر دون اتفاق، سيتم تطبيق إجراءات إدارية - بما في ذلك تعليق النقل وحجب الشهادات</li>
    <li>في‭ ‬حال‭ ‬التعليم‭ ‬المباشر‭ ‬حسب‭ ‬رزنامة‭ ‬الوزارة‭ (‬القرار‭ ‬الوزاري‭ ‬194/2021‭)‬،‭ ‬يتم‭ ‬تحصيل‭ ‬الرّسوم‭ ‬كاملة‭ ‬وفق‭ ‬الجدول‭.‬</li>
    <li>تُعتبر‭ ‬الإجازات‭ ‬الرسمية‭ ‬ضمن‭ ‬الأيام‭ ‬الدراسيّة‭ ‬وتستمرّ‭ ‬الرسوم‭ ‬خلالها‭ ‬بدون‭ ‬انقطاع‭.‬</li>
  </ul>
  `,
  distanceLearningPaymentTitle: "نظام‭ ‬الدّفع‭ ‬المالي‭ ‬في‭ ‬التّعليم‭ ‬عن‭ ‬بُعد",
  distanceLearningPayment:[ `
  <ul>
    <li>يلتزم‭ ‬وليّ‭ ‬الأمر‭ ‬لدى‭ ‬تحوّل‭ ‬التعليم‭ ‬إلى‭ ‬نظام‭ ‬التعليم‭ ‬عن‭ ‬بُعد‭ ‬بإكمال‭ ‬الشّهر‭ ‬الجارِي‭ ‬إلى‭ ‬آخره‭ ‬ودفع‭ ‬مُستحقّاته‭ ‬كاملةً،‭ ‬ولا‭ ‬يُسمح‭ ‬له‭ ‬بالانسحاب‭ ‬أو‭ ‬الاستمرار‭ ‬إلاّ‭ ‬بعد‭ ‬انقضاء‭ ‬الشّهر‭.‬</li>
    <li>لا‭ ‬يُعتمد‭ ‬تخفيض‭ ‬الرسوم‭ ‬للتعليم‭ ‬عن‭ ‬بُعد‭ ‬حسب‭ ‬الوارد‭ ‬في‭ ‬<a href="/expenses"><span style="background-color: #e63967; color: white; padding: 4px 16px; border-radius: 8px; text-decoration: none;">جدول‭ ‬الرسوم</span></a></span></a> ‬إلا‭ ‬إذا‭ ‬كان‭ ‬القرار‭ ‬لمدة‭ ‬تزيد‭ ‬عن‭ ‬31‭ ‬يومًا‭ ‬ـ‭ ‬من‭ ‬غير‭ ‬احتساب‭ ‬الإجازات‭ ‬الرسمية‭.‬</li>
    <li>في‭ ‬جميع‭ ‬الحالات‭ ‬لا‭ ‬تخضع‭ ‬رسوم‭ ‬مُقدّم‭ ‬الدفع‭ ‬والكتب‭ ‬والتغذية‭ ‬لأيّ‭ ‬تعديل‭ ‬أو‭ ‬تجزئة‭.‬</li>
    <li>في حال تبين للمدرسة أن الطالب يعاني من صعوبات تعلم أو احتياجات خاصة أو مشاكل أخرى، يحق للمدرسة فسخ التعاقد مع إلزام ولي الأمر بدفع مقدم التسجيل والشهور التي قضاها الطالب في المدرسة.</li>
  </ul>
  `],
    directLearningPaymentTitle: "نظام‭ ‬الدّفع‭ ‬المالي‭ ‬في‭ ‬التّعليم‭ ‬الْمُباشر",
  directLearningPayment: [`
  <ul>
    <li>يلتزم‭ ‬الطّرف‭ ‬الثاني‭ ‬بدفع‭ ‬الأقساط‭ ‬كاملةً‭ ‬من‭ ‬أوّل‭ ‬شهر‭ ‬إلى‭ ‬آخر‭ ‬شهر‭ ‬في‭ ‬السنة‭ ‬الدراسيّة،‭ ‬ولا‭ ‬تُجزّأ‭ ‬الرّسوم‭ ‬بحسب‭ ‬الأيّام‭ ‬الدراسيّة‭ ‬ولا‭ ‬تُستقطع‭ ‬الأيّام‭ ‬من‭ ‬الشّهور‭ ‬النّاقصة‭.‬</li>
    <li>في‭ ‬حال‭ ‬حدوث‭ ‬تعديل‭ ‬طارئ‭ ‬واستثنائيّ‭ ‬من‭ ‬قبل‭ ‬وزارة‭ ‬التربية‭ ‬على‭ ‬الرّزنامة‭ ‬السنويّة‭ ‬لبداية‭ ‬السنة‭ ‬أو‭ ‬نهايتها‭ ‬فقط؛‭ ‬فإنّ‭ ‬المؤسّسة‭ ‬تعتمد‭ ‬القاعدة‭ ‬الآتية‭:‬ إذا‭ ‬كان‭ ‬عدد‭ ‬أيّام‭ ‬الدراسة‭ ‬في‭ ‬الشّهر‭ ‬أقلّ‭ ‬من‭ ‬15‭ ‬يوما؛‭ ‬فإنّه‭ ‬يُدفع‭ ‬نصف‭ ‬القسط‭ ‬الشّهريّ،‭ ‬وإن‭ ‬كان‭ ‬يساوي‭ ‬أو‭ ‬أكثر‭ ‬من‭ ‬15‭ ‬يوما؛‭ ‬فإنّ‭ ‬القسط‭ ‬الشّهريّ‭ ‬يُدفع‭ ‬كاملا‭.‬</li>
  </ul>
  `],
search:"بحث",
    "switchtoAccount":"تبدبل الي",

studentregistering:"طالب يسجل اول مره بالمدرسة",
studyingatschool:"طالب يدرس بالمدرسة",
  newStudentTitle: "طالب مستجد (يسجل لأول مرة بالمدرسة)",
  newStudentDescription: "قبل متابعة التسجيل، يرجى التأكد من توفير المستندات التالية:",
  newStudentDocuments: [`
  <ul>
    <li>البطاقة الشخصية / بطاقة الإقامة لولي الأمر</li>
    <li>بطاقة الإقامة للطالب الوافد</li>
    <li>الصورة الشخصية للطالب</li>
    <li>صورة جواز سفر الطالب في حال توفره</li>
    <li>صورة شهادة ميلاد الطالب</li>
    <li>صورة البطاقة الصحية</li>
  </ul>
  `],
  newStudentSelectGrade: "يرجى تحديد الصف الدراسي",
  FromgradesPostprimary:" من الصف العاشر الى الصف الثاني عشر",
  FromgradesBasic:"من الصف الاول الى الصف التاسع",
Needsfollowup:"يحتاج إلى متابعة",
Good:"جيد",
Excellent:"ممتاز",
chronicillnesses:"يعاني من أمراض مزمنة؟",
particularfood:"لديه حساسية من وجبة معينة؟",
Othernotes:"ملاحظات أخرى",
Other:"أخرى",

Studenteducationaldata:"بيانات الطالب التعليمية",
yes:"نعم",
No:"لا",
studiedbefore:"هل سبق له الدراسة؟",
Previousschooldata:"Previous school data"

  },


};



